<template>
  <div>
    <div v-for="bet in bets" :key="bet.event">
      <v-divider></v-divider>
      <div class="font-weight-bold caption mx-4 mt-2">
        {{ bet.matchName }}
      </div>
      <div v-for="(market, m) in bet.markets" :key="'market' + m">
        <div v-for="(runner, r) in market.runners" :key="'runners' + r">
          <div v-if="runner.average.length">
            <div
              v-for="(averageBets, b) in runner.average"
              :key="b + averageBets.horse"
            >
              <div class="caption mx-4 mt-1">
                {{ averageBets.horse }} - {{ averageBets.marketName }}
              </div>
              <div>
                <v-simple-table tile dense>
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="text-left caption font-weight-bold">Odds</th>
                        <th class="text-left caption font-weight-bold">
                          Stake
                        </th>
                        <th class="text-left caption font-weight-bold">
                          Profit/Liability
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        :class="{
                          back: averageBets.type === 'BACK',
                          lay: averageBets.type === 'LAY'
                        }"
                      >
                        <td class="caption font-weight-bold">
                          <span
                            v-if="
                              averageBets.betType !== 'bookMaker' &&
                              averageBets.betType !== 'lineLadder'
                            "
                          >
                            {{
                              averageBets.averagePriceMatched
                                | currencyFormat(3)
                            }}
                          </span>
                          <span v-if="averageBets.betType === 'lineLadder'">
                            {{ averageBets.averagePriceMatched | ceil }}
                          </span>
                          <span v-if="averageBets.betType === 'bookMaker'">
                            {{
                              ((averageBets.averagePriceMatched - 1) * 100)
                                | currencyFormat(3)
                            }}
                          </span>
                        </td>
                        <td class="caption font-weight-bold">
                          {{ averageBets.stake | currencyFormat(0) }}
                        </td>
                        <td class="caption font-weight-bold">
                          <span
                            v-if="
                              averageBets.betType !== 'bookMaker' &&
                              averageBets.betType !== 'lineLadder'
                            "
                          >
                            {{
                              calculateWinnings(
                                averageBets.averagePriceMatched,
                                averageBets.stake
                              ) | currencyFormat(0)
                            }}
                          </span>
                          <span v-if="averageBets.betType === 'bookMaker'">
                            {{
                              calculateWinnings(
                                averageBets.averagePriceMatched,
                                averageBets.stake
                              ) | currencyFormat(2)
                            }}
                          </span>
                          <span v-if="averageBets.betType === 'lineLadder'">
                            {{
                              calculateWinnings(
                                averageBets.betRate,
                                averageBets.stake
                              ) | currencyFormat(2)
                            }}
                          </span>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import multiply from 'lodash/multiply'
import subtract from 'lodash/subtract'
import round from 'lodash/round'
export default {
  name: 'AverageBets',
  props: {
    bets: { type: Array, default: () => [], required: true }
  },
  data() {
    return {
      event: {}
    }
  },
  created() {
    if (
      this.bets.length &&
      this.bets[0].betData &&
      this.bets[0].betData.length
    ) {
      this.event = this.bets[0].betData[0]
    }
  },
  methods: {
    calculateWinnings(odds, stake) {
      if (stake > 0 && odds > 0) {
        const m = multiply(parseFloat(odds), parseFloat(stake))
        const s = subtract(m, parseFloat(stake))
        return round(s, 2) / this.getMyRate()
      }
    }
  }
}
</script>

<style scss>
.back {
  background: var(--v-secondary-base) !important;
}
.lay {
  background: var(--v-accent-base) !important;
}
</style>
